"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AppSyncConsumer {
    constructor(appSyncClient) {
        this._client = appSyncClient;
    }
}
exports.default = AppSyncConsumer;
//# sourceMappingURL=AppSyncConsumer.js.map